import { Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { IoMdCloseCircle } from "react-icons/io";
// import { GoPrimitiveDot } from "react-icons/go";

export default function CreditScoreInfoModal({
  isModalVisible,
  handleOk,
  handleCancel,
}) {
  const { t } = useTranslation();
  return (
    <Modal
      title=""
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      maskClosable={false}
      destroyOnClose={true}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* <div style={{ flex: 9 }}>
          <h2>{t("creditScore.averageCreditScore")}</h2>
        </div> */}
        {/* <div style={{ flex: 1 }} onClick={handleCancel}>
          <IoMdCloseCircle style={{ fontSize: "29px", color: "grey" }} />
        </div> */}
     
      {/* <div style={{ marginTop: "10px", width: "90%" }}>
        <p style={{ fontSize: "15px", lineHeight: "17px" }}>
          {t("creditScore.youMayStruggle")}
        </p>
      </div> */}
      <div style={{ flex: 9 }}>
      <h3>{t("creditScore.range")}</h3>
      </div>
      <div style={{ flex: 1 }} onClick={handleCancel}>
          <IoMdCloseCircle style={{ fontSize: "29px", color: "grey" }} />
        </div>
        </div>
      <div
        style={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "15px 0px",
            display: "flex",
            textAlign: "center",
            backgroundColor: "lightgray",
          }}
        >
          <div style={{ flex: 1 }}>{t("creditScore.category")}</div>
          <div style={{ flex: 1 }}>{t("creditScore.ranges")}</div>
        </div>
        <div
          style={{
            padding: "10px 0px",
            display: "flex",
            textAlign: "center",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              color: "#00CC66",
            }}
          >
            <div>
              {/* <GoPrimitiveDot
                style={{
                  fontSize: "15px",
                  marginTop: "5px",
                  marginRight: "5px",
                }}
              /> */}
            </div>
            <div style={{ fontSize: "15px" }}>{t("creditScore.excellent")}</div>
          </div>
          <div style={{ flex: 1, color: "#696969" }}>780-900</div>
        </div>
        <div
          style={{
            padding: "10px 0px",
            display: "flex",
            textAlign: "center",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              color: "#90EE90",
            }}
          >
            <div>
              {/* <GoPrimitiveDot
                style={{
                  fontSize: "15px",
                  marginTop: "5px",
                  marginRight: "5px",
                  marginLeft: "-21px",
                }}
              /> */}
            </div>
            <div style={{ fontSize: "15px" }}>{t("creditScore.good")}</div>
          </div>
          <div style={{ flex: 1, color: "#696969" }}>700-779</div>
        </div>
        <div
          style={{
            padding: "10px 0px",
            display: "flex",
            textAlign: "center",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              color: "#F6BE00",
            }}
          >
            <div>
              {/* <GoPrimitiveDot
                style={{
                  fontSize: "15px",
                  marginTop: "5px",
                  marginRight: "5px",
                }}
              /> */}
            </div>
            <div style={{ fontSize: "15px" }}>{t("creditScore.average")}</div>
          </div>
          <div style={{ flex: 1, color: "#696969" }}>600-699</div>
        </div>
        <div
          style={{
            padding: "10px 0px",
            display: "flex",
            textAlign: "center",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              color: "red",
            }}
          >
            <div>
              {/* <GoPrimitiveDot
                style={{
                  fontSize: "15px",
                  marginTop: "5px",
                  marginRight: "5px",
                  marginLeft: "-21px",
                }}
              /> */}
            </div>
            <div style={{ fontSize: "15px" }}>{t("creditScore.poor")}</div>
          </div>
          <div style={{ flex: 1, color: "#696969" }}>{"< 600"}</div>
        </div>
      </div>
      <div style={{ color: "#B0B0B0", lineHeight: "18px", marginTop: "10px" }}>
        <p>{t("creditScore.theseScores")}</p>
      </div>
      <div
        style={{
          padding: "15px 0",
          textAlign: "center",
          backgroundColor: "#6C63FF",
          color: "white",
          borderRadius: "5px",
          fontWeight: 600,
          fontSize: "15px",
        }}
        onClick={handleCancel}
      >
        {t("creditScore.okay")}
      </div>
    </Modal>
  );
}
